import React from 'react';
import ErrorPage from './ErrorPage';

const Error400 = () => <ErrorPage code={400} />;

export default Error400;
